/**
 * The cash-drawer kick. Port of web `printHelper.js` `openCashDrawer` (:32).
 *
 * A drawer hangs off the receipt printer, so the kick is just two bytes of text sent to it. Sunmi's
 * built-in Bluetooth printer ("innerprinter") takes its own vendor command instead of `ESC p`.
 */
import type { CashDrawerInput, Piece, Plan, PrintContext, PrinterRecord } from "../types";
import { isEmpty } from "../util";

export const DRAWER_KICK = "ESC p 0 25 250";
export const INNER_PRINTER_DRAWER_KICK = "SPR 20 0 0 0";

/**
 * The drawer on its own — v1's header button, which kicks the default printer's drawer with no
 * bill attached. The same piece a bill plans, as its own document so it goes through the queue
 * instead of racing whatever is printing.
 */
export function planDrawer(input: CashDrawerInput, ctx: PrintContext): Plan {
  const printer = input.printer ?? ctx.printers.defaultPrinter ?? {};
  if (isEmpty(printer)) return { pieces: [], skipped: [{ reason: "noDefaultPrinter" }] };
  return { pieces: [drawerPiece(printer)], skipped: [] };
}

export function drawerPiece(printer: PrinterRecord): Piece {
  const innerPrinter = printer?.label?.toLowerCase() === "innerprinter" && printer?.printerType === "BLUETOOTH";
  return {
    document: "drawer",
    destination: { to: "printer", printer },
    copies: 1,
    source: { kind: "text", text: innerPrinter ? INNER_PRINTER_DRAWER_KICK : DRAWER_KICK },
  };
}
